// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (max-width: 1400px) {\n.responsive-button[data-v-0ad2d78a] {\n    min-height: 70px;\n}\n}", "",{"version":3,"sources":["webpack://./src/pages/alerts/AlertsPage.vue"],"names":[],"mappings":"AAEA;AACE;IACE,gBAAA;AADF;AACF","sourcesContent":["\n\n@media (max-width: 1400px) {\n  .responsive-button {\n    min-height: 70px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
